import styled from 'styled-components'
import { paperBackgroundCss } from './sharedStyles'
import { unstyledButtonCss } from './sharedStyles'

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
`

Pagination.ButtonsWrapper = styled.div`
  ${paperBackgroundCss}
  padding: 0.5rem;
`

Pagination.Button = styled.button`
  ${unstyledButtonCss}
  text-align: center;
  padding: 0.5rem;
  transition: all ease-in-out 0.3s;
  color: ${props => (props.isActive ? '#000' : '#222')};
  transform: ${props => (props.isActive ? 'scale(1.3)' : 'initial')};
  border-bottom: 1px solid ${props => (props.isActive ? '#000' : 'transparent')};
  margin: 0 0.2rem;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
`

export default Pagination
